import { render, staticRenderFns } from "./rechargeDoc.vue?vue&type=template&id=b737451c&scoped=true&"
import script from "./rechargeDoc.vue?vue&type=script&lang=js&"
export * from "./rechargeDoc.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDoc.vue?vue&type=style&index=0&id=b737451c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b737451c",
  null
  
)

export default component.exports